import { Box, Flex, Portal, Text } from '@chakra-ui/react';
import { Line } from 'rc-progress';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import { FiUpload } from 'react-icons/fi';

interface UploadInputProps {
  onDrop: (acceptedFiles: File[]) => void;
  isUploading: boolean;
  progress?: number;
  withPortal?: boolean;
  maxFiles?: number;
}

const UploadInput: React.FC<UploadInputProps> = ({
  onDrop,
  isUploading,
  progress,
  withPortal,
  maxFiles = 20,
}) => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles,
    disabled: isUploading,
  });

  const content = (
    <Box
      {...getRootProps()}
      borderWidth="2px"
      borderStyle="dashed"
      borderRadius="md"
      p={6}
      textAlign="center"
      cursor={isUploading ? 'not-allowed' : 'pointer'}
      _hover={{ bg: 'gray.50' }}
    >
      <input {...getInputProps()} />
      <Flex direction="column" alignItems="center" justifyContent="center">
        <FiUpload size={32} />
        <Text mt={2}>
          {isUploading
            ? t('common.sending_file')
            : t('common.drag_files_or_click', { maxFiles })}
        </Text>
        {isUploading && progress !== undefined && (
          <Box width="100%" mt={4}>
            <Line
              percent={progress}
              strokeWidth={4}
              strokeColor="#0794B2"
              trailColor="#EBEBEB"
            />
          </Box>
        )}
      </Flex>
    </Box>
  );

  if (withPortal) {
    return <Portal>{content}</Portal>;
  }

  return content;
};

export default UploadInput;
